/** Same shape as AdminZipCode — Django / DRF / ResponseFormatter errors → one string. */

export function formatApiErrorBody(body: unknown): string {
  if (body == null) return "";
  if (typeof body === "string" && body.trim()) return body.trim();
  if (typeof body !== "object") return String(body);

  const b = body as Record<string, unknown>;
  const segments: string[] = [];
  const pushUnique = (s: string) => {
    const t = s.trim();
    if (t && !segments.includes(t)) segments.push(t);
  };

  const msg = b.message;
  if (typeof msg === "string" && msg.trim()) pushUnique(msg);
  const errStr = b.error;
  if (typeof errStr === "string" && errStr.trim()) pushUnique(errStr);
  const detail = b.detail;
  if (typeof detail === "string" && detail.trim()) pushUnique(detail);
  if (Array.isArray(detail)) {
    const joined = detail.map((x) => String(x)).filter(Boolean).join("; ");
    if (joined) pushUnique(joined);
  }
  const nfe = b.non_field_errors;
  if (Array.isArray(nfe)) {
    const joined = nfe.map((x) => String(x)).filter(Boolean).join("; ");
    if (joined) pushUnique(joined);
  }
  const errors = b.errors;
  if (errors != null && typeof errors === "object" && !Array.isArray(errors)) {
    const lines: string[] = [];
    for (const [k, v] of Object.entries(errors as Record<string, unknown>)) {
      if (Array.isArray(v)) {
        const parts = v.map((x) => String(x)).filter(Boolean);
        if (parts.length) lines.push(`${k}: ${parts.join(", ")}`);
      }
    }
    if (lines.length) pushUnique(lines.join("\n"));
  }
  return segments.join("\n\n");
}

export function errorMessageFromParsedBody(body: unknown, fallback: string): string {
  const formatted = formatApiErrorBody(body);
  return formatted || fallback;
}
